export const POST_BUG_REPORT = 'POST_BUG_REPORT'
export const POST_BUG_REPORT_ERROR = `POST_BUG_REPORT_ERROR`
export const POST_BUG_REPORT_SUCCESS = `POST_BUG_REPORT_SUCCESS`
